"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Training = void 0;
const react_1 = __importDefault(require("react"));
const ProviderTabs_styles_1 = require("../../ProviderTabs.styles");
const TrainingTable_1 = require("./TrainingTable");
const Training = ({ labels: { tableHeaderLabels, nextPageLabel = 'Next', previousPageLabel = 'Previous', noRecordsLabel = 'This provider does not have any records on file.', noRecordsOnSearchLabel = 'No records could be found that match your search criteria. Please remove your search term and try again.' } = {}, provider, stateEventHandlers }) => {
    const { training = [] } = provider;
    return (react_1.default.createElement(ProviderTabs_styles_1.Content, { "data-testid": "training" },
        react_1.default.createElement(TrainingTable_1.TrainingTable, { id: `${provider.id}-training`, labels: {
                tableHeaderLabels,
                nextPageLabel,
                previousPageLabel,
                noRecordsLabel,
                noRecordsOnSearchLabel
            }, training: training, stateEventHandlers: stateEventHandlers })));
};
exports.Training = Training;
//# sourceMappingURL=Training.js.map